export enum REQUESTS_PATH {
    HAZARD = '/HazardClasses'
}
